module.exports = __webpack_public_path__ + "img/twitter.a9f59c36.svg";